export const MOBILE_HANDOFF_AT_KEY = 'ncof-mobile-handoff-at';
export const MOBILE_HANDOFF_GUARD_MS = 8_000;

export const markMobileHandoffStarted = (now = Date.now()): void => {
  try {
    sessionStorage.setItem(MOBILE_HANDOFF_AT_KEY, String(now));
  } catch {
    // sessionStorage can be unavailable in some in-app browsers.
  }
};

export const isRecentMobileHandoff = (now = Date.now()): boolean => {
  try {
    const raw = sessionStorage.getItem(MOBILE_HANDOFF_AT_KEY);
    if (!raw) return false;
    const at = Number(raw);
    if (!Number.isFinite(at)) return false;
    return now - at < MOBILE_HANDOFF_GUARD_MS;
  } catch {
    return false;
  }
};
